import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { MultiSelect } from "react-multi-select-component";
import { Link, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import logo from './assets/images/logo.png';
import LanguageBtn from './LanguageBtn';
//import { I18nProvider, LOCALES } from './i18n';
//import { FormattedMessage } from 'react-intl';
//import translate from './i18n/translate';
import Loader from './Loader';

import './App.css';

const News = () => {

  let history = useHistory();
  let { id } = useParams();
  const [multi_topics_obj, setSelected] = useState([]);
  const [multi_topics, setMultiTopic] = useState([]);
  const [value, setValue] = useState('');
  const [cats, setCat] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [options_multi, setMulti] = useState([]);
  const [topcs, setTopc] = useState([]);
  const [typs, setTyps] = useState([]);

  const [otherCats, setOtherCat] = useState([]);
  const [otherTopcs, setOtherTopc] = useState([]);
  const [otherTyps, setOtherTyps] = useState([]);

  const [posts, setPost] = useState([]);
  const [filteredPost, setFilteredPost] = useState([]);
  const [data, setData] = useState([]);
  const [engActive, setEngActive] = useState(false);
  const [languageData, setLanguageData] = useState([]);

  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [topic, setTopic] = useState('');
  const [type, setType] = useState('');
  const [author, setAuthor] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [Id, setId] = useState(0);

  const [isFilterApplied, setFilterApplied] = useState(false);

  const [showTitle, setShowTitle] = useState('');
  const [isLoader, setLoader] = useState(false);


  const [lblSearchByTitle, setSearchByTitle] = useState('');
  const [lblSearchDocument, setSearchDocument] = useState('');
  const [btnSearch, setSearch] = useState('');
  const [lblDocumentList, setDocumentList] = useState('');
  const [lblSearchByCategory, setSearchByCategory] = useState('');
  const [lblSearchByTopic, setSearchByTopic] = useState('');
  const [lblSearchByType, setSearchByType] = useState('');
  const [lblSelectCategory, setSelectCategory] = useState('');
  const [lblSelectTopic, setSelectTopic] = useState('');
  const [lblSelectType, setSelectType] = useState('');
  const [lblTopic, setLblTopic] = useState('');
  const [lblCategory, setLblCategory] = useState('');
  const [lblType, setLblType] = useState('');
  const [lblLibraryItemID, setLblItemID] = useState('');
  const [lblAuthor, setLblAuthor] = useState('');
  const [lblEnterTitleName, setEnterTitleName] = useState('');
  const [isLoading, setIsLoading] = useState(false)


  const [separator, setSeparator] = useState(true);

  const handleTitleChange = ({ target }) => {
    setTitle(target.value);
  };

  const handleAuthorChange = ({ target }) => {
    setAuthor(target.value);

  };

  const handleCategoryTypeChange = ({ target }) => {
    //  console.log(target.value);
    setCategory(target.value);
    // console.log(target.value,category);    
  };

  const handleTopicTypeChange = ({ target }) => {
    setTopic(target.value);

  };

  const handleTypeChange = ({ target }) => {
    setType(target.value);
  };

  const handleMultiTopicChange = (e) => {
    setSelected(e);
    setMultiTopic([]);
    if (e.length > 0) {
      let topic_arr = [];
      for (let i = 0; i < e.length; i++) {
        console.log(e[i].value);
        topic_arr.push(e[i].value);
      }
      setMultiTopic(topic_arr)
    }
  };

  const handleDocumentId = ({ target }) => {
    setDocumentId(target.value);
  };



  const handleClick = event => {
    setEngActive(!engActive);
    // console.log(event.target.className);
  }

  const filterData = (e) => {
    
    e.preventDefault();
    setLoader(true);
    loadFilterDocuments();
    setLoader(false);
    // console.log("Title=======>", title);
    // console.log("Category=======>", category);
    // console.log("Topic=======>", topic);
    // console.log("Type=======>", type);
    // console.log("Document Id=======>", documentId);

  }


  useEffect(() => {
    if (type != '' || topic != '' || author != '') {
      setLoader(true);
      loadFilterDocuments();
      setLoader(false);
    }
    else {
      loadDocuments();
      loadMasterData();
      localSelect();
      selectedLanguageData();
    }
    // console.log(category);
  }, [category, type, topic, author]);


  const localSelect = () => {
    let getLangs = localStorage.getItem('language');
  }

  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  }

  let getDocumentFormData = new FormData();
  getDocumentFormData.set('title', '');
  getDocumentFormData.set('language_id', localStorage.getItem('languageId'));
  getDocumentFormData.set('from_portal', localStorage.getItem('from_portal'));
  getDocumentFormData.set('topic_id', '');
  getDocumentFormData.set('type_id', '');
  getDocumentFormData.set('document_id', '');
  getDocumentFormData.set('author', '');



  let formData = new FormData();

  formData.set('title', title);
  formData.set('language_id', localStorage.getItem('languageId'));
  formData.set('topic_id', multi_topics);
  formData.set('from_portal', localStorage.getItem('from_portal'));
  formData.set('type_id', type);
  formData.set('document_id', documentId);
  formData.set('author', author);


  let getmasterFormData = new FormData();
  getmasterFormData.set('language_id', localStorage.getItem('languageId'));

  let getLanFormData = new FormData();
  getLanFormData.set('language_id', localStorage.getItem('languageId'));


  const loadDocuments = async () => {
    setLoader(true);
    setFilterApplied(false);
    let langId = localStorage.getItem('languageId');
    setId(langId);
    //console.log('show id here', langId);
    // console.log('-----============>', getDocumentFormData.getAll('language_id'));
    const result = await axios.post('/api/getdocuments', getDocumentFormData, config)
    //console.log(result.data);
    setPost(result.data.document);
    setLoader(false);
    //setTotalDocs(result.data.length);
  }

  const selectedLanguageData = async () => {
    setLoader(true);
    let getLang = localStorage.getItem('language');
    const result = await axios.post('/api/get_translated_captions', getLanFormData, config);
    // console.log('********=>', result.data.length);
    setLanguageData(result.data);
    if (getLang === 'English') {
      setSeparator(false);
    }
    if (result.data.length < 1) {
      setShowTitle("English");
      setSeparator(false);
    }
    else {
      setShowTitle(getLang);
    }
    setLoader(false);
    {
      result.data.map(lanData => {
        lanData.caption_key === "lblSearchByTitle" &&
          setSearchByTitle(lblSearchByTitle => [...lblSearchByTitle, lanData.translated_text]);

        lanData.caption_key === "lblSearchByCategory" &&
          setSearchByCategory(lblSearchByCategory => [...lblSearchByCategory, lanData.translated_text]);

        lanData.caption_key === "lblSearchByTopic" &&
          setSearchByTopic(lblSearchByTopic => [...lblSearchByTopic, lanData.translated_text]);

        lanData.caption_key === "lblSearchByType" &&
          setSearchByType(lblSearchByType => [...lblSearchByType, lanData.translated_text]);

        lanData.caption_key === "lblSearchDocument" &&
          setSearchDocument(lblSearchDocument => [...lblSearchDocument, lanData.translated_text]);

        lanData.caption_key === "lblDocumentsList" &&
          setDocumentList(lblDocumentList => [...lblDocumentList, lanData.translated_text]);

        lanData.caption_key === "lblSearch" &&
          setSearch(btnSearch => [...btnSearch, lanData.translated_text]);

        lanData.caption_key === "btnSearch" &&
          setSearch(btnSearch => [...btnSearch, lanData.translated_text]);

        lanData.caption_key === "lblTopic" &&
          setLblTopic(lblTopic => [...lblTopic, lanData.translated_text]);

        lanData.caption_key === "lblType" &&
          setLblType(lblType => [...lblType, lanData.translated_text]);

        lanData.caption_key === "lblLibraryItemID" &&
          setLblItemID(lblLibraryItemID => [...lblLibraryItemID, lanData.translated_text]);

        lanData.caption_key === "lblCategory" &&
          setLblCategory(lblCategory => [...lblCategory, lanData.translated_text]);

        lanData.caption_key === "lblSelectCategory" &&
          setSelectCategory(lblSelectCategory => [...lblSelectCategory, lanData.translated_text]);

        lanData.caption_key === "lblSelectTopic" &&
          setSelectTopic(lblSelectTopic => [...lblSelectTopic, lanData.translated_text]);

        lanData.caption_key === "lblSelectType" &&
          setSelectType(lblSelectType => [...lblSelectType, lanData.translated_text]);

        lanData.caption_key === "lblEnterTitleName" &&
          setEnterTitleName(lblEnterTitleName => [...lblEnterTitleName, lanData.translated_text]);

        lanData.caption_key === "lblAuthor" &&
          setLblAuthor(lblAuthor => [...lblAuthor, lanData.translated_text]);
      }

      )
    }
  }

  const loadMasterData = async () => {
    setIsLoading(true)
    const result = await axios.post('/api/getmasterdata', getmasterFormData, config)
    // console.log(result.data);
    setCat(result.data.categories);
    var authors_data = (typeof result.data.author != 'undefined') ? result.data.author : [];
    setAuthors(authors_data);
    setTopc(result.data.topics);
    setTyps(result.data.types);
    let options_data = [];
    if (result.data.topics.length > 0) {
      let topic_data = result.data.topics;
      for (var i = 0; i < topic_data.length; i++) {
        if (topic_data[i].total_documents > 0) {
          var option_data = {};
          var translated_topic = '';
          if (topic_data[i].otherlanguage.length > 0) {
            let trans_topic = topic_data[i].otherlanguage;
            for (var j = 0; j < trans_topic.length; j++) { // You can use `let` instead of `const` if you like
              if ((localStorage.getItem('languageId') == trans_topic[j].languageID) && localStorage.getItem('languageId') != 26) {
                translated_topic = trans_topic[j].translatedtext;
              }
            }
          }
          option_data['label'] = topic_data[i].topicName + (separator === true ? '/ ' : '') + topic_data[i].total_documents + ' ' + translated_topic;
          option_data['value'] = topic_data[i].topicID;
          options_data.push(option_data);
        }
      }
      setMulti(options_data);
      setIsLoading(false)
    }
    // console.log('Topics:------', result.data.topics);

    {
      if (!!result.data.topics)
        result.data.topics.map(othertopic => {
          othertopic.otherlanguage && othertopic.otherlanguage.map(item => item.languageID === localStorage.getItem('languageId') &&
            setOtherTopc(otherTopcs => [...otherTopcs, item.translatedtext])
          )
        }
        )
    }

    {
      if (!!result.data.categories)
        result.data.categories.map(othercat => {
          othercat.otherlanguage && othercat.otherlanguage.map(item => item.languageID === localStorage.getItem('languageId') &&
            setOtherCat(otherCats => [...otherCats, item.translatedtext])
          )
        }
        )
    }

    {
      result.data.types.map(othertype => {
        othertype.otherlanguage && othertype.otherlanguage.map(item => item.languageID === localStorage.getItem('languageId') &&
          setOtherTyps(otherTyps => [...otherTyps, item.translatedtext])
        )
      }
      )
    }
    // console.log('other_cat', otherCats);

  }


  const loadFilterDocuments = async () => {
    formData.set('title', title);
    setFilterApplied(true)
    formData.set('language_id', localStorage.getItem('languageId'));
    formData.set('from_portal', localStorage.getItem('from_portal'));
    formData.set('topic_id', multi_topics);
    formData.set('type_id', type);
    formData.set('document_id', documentId);
    formData.set('author', author);
    const result = await axios.post('/api/getdocuments', formData, config)
    setFilteredPost(result.data.document || []);
  }

  const DocumentSection = ({ post }) => {
    return (<Link to={`/detail/${post.documentID}`}>
      <div className="card ">
        <div className="card-body">

          <h5 className="card-title">
            {post.title} <br /> {post.title_translated}
            {/* <p className="mt-2">
                    {post.title}
                </p> */}
          </h5>



          <div className="file-details">
            {post.topic_translated != '' &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>{lblTopic}</h6>
                </div>
                <div className="col-9">
                  {post.topic_translated}
                </div>
              </div>
            }
            <div className="row no-gutters">

              <div className="col-3">
                <h6>Topic</h6>
              </div>
              <div className="col-9">
                <p>{post.topicName}</p>
              </div>
            </div>

            {post.type_translated != '' &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>{lblType}</h6>
                </div>
                <div className="col-9">
                  {post.type_translated}
                </div>
              </div>
            }

            <div className="row no-gutters">
              <div className="col-3">
                <h6>Type</h6>
              </div>
              <div className="col-9">
                <p>{post.typeName}</p>
              </div>
            </div>

            {post.author_contact != '' && post.author_contact != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Author Contact</h6>
                </div>
                <div className="col-9">
                  <p><a onClick={() => { window.open(post.author_contact, '_blank') }} style={{ cursor: "pointer" }}><u>Author Contact</u></a></p>
                </div>
              </div>
            }

            {post.countryName != '' && post.countryName != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Country</h6>
                </div>
                <div className="col-9">
                  <p>{post.countryName}</p>
                </div>
              </div>
            }

            {post.provinceName != '' && post.provinceName != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Province</h6>
                </div>
                <div className="col-9">
                  <p>{post.provinceName}</p>
                </div>
              </div>
            }

            {post.publication_date != '' && post.publication_date != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Publication Date</h6>
                </div>
                <div className="col-9">
                  <p>{post.publication_date}</p>
                </div>
              </div>
            }

            {post.sponsered_by != '' && post.sponsered_by != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Sponsored/Endorsed By</h6>
                </div>
                <div className="col-9">
                  <p>{post.sponsered_by}</p>
                </div>
              </div>
            }

            {post.item_note_en != '' && post.item_note_en != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Item Note - EN</h6>
                </div>
                <div className="col-9">
                  <p>{post.item_note_en}</p>
                </div>
              </div>
            }

            {post.item_note_fr != '' && post.item_note_fr != null &&
              <div className="row no-gutters">
                <div className="col-3">
                  <h6>Item Note - FR</h6>
                </div>
                <div className="col-9">
                  <p>{post.item_note_fr}</p>
                </div>
              </div>
            }
          </div>
          <i className="fa fa-angle-right fa-3x pull-right arrow" aria-hidden="true"></i>


        </div>
      </div>
    </Link>)
  }


  return (
    <div>

      <div className="container top-header sticky-top box-shadow">
        <img src={logo} style={{ width: "120px" }} alt="logo" />
        <Link to="/rechoose_language">
          <button title="Choose Language" className="float-right lng_btn">
            <i className="fa fa-language" aria-hidden="true"></i></button></Link>
        <h4 className="text-center">Search Documents {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblSearchDocument : ''}</h4>
      </div>
      <div className="container-fuild">
        <div className="container select-language">

          <nav>
            <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
              <a
                className='nav-item nav-link active'
                id="nav-profile-tab"
                data-toggle="tab"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                onClick={handleClick}
              >English {separator === true ? '/ ' : ''}{showTitle !== 'English' ? showTitle : ''}</a>
            </div>
          </nav>
          <div className="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">

            <div
              className='tab-pane active'
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab">
              <form>
                <div className="row">
                  <div className="col-12">
                    <label>Search by Title {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblSearchByTitle : ''}</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={lblEnterTitleName === '' || showTitle === 'English' ? 'Enter Title Keywords' : 'Enter Title Keywords/' + lblEnterTitleName}
                      onChange={handleTitleChange}
                      value={title}
                    />
                  </div>

                  {/* <div className="col-6 mt-4">
                      <label>Search by Document Id {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblLibraryItemID : ''}</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={lblEnterTitleName === '' || showTitle === 'English' ? 'Enter Document Id' : 'Enter Document Id/'+lblLibraryItemID}
                        onChange={handleDocumentId}
                        value={documentId}
                      />
                    </div> */}

                </div>
                <div className="row mt-4">
                  <div className="col-4">
                    <label>Search by Author {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblAuthor : ''}</label>
                    <select
                      className="form-control"
                      onChange={handleAuthorChange}>
                      <option value="">Select Author{separator === true ? '/ ' : ''}{showTitle === 'English' ? '' : ''}</option>
                      {
                        authors.map((author, index) =>
                          <option value={author.author}>{author.author}{separator === true ? '/ ' : ''}</option>
                        )}
                    </select>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label>Search by Topic {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblSearchByTopic : ''}</label>
                      <MultiSelect
                        options={options_multi}
                        value={multi_topics_obj}
                        onChange={(e) => handleMultiTopicChange(e)}
                        labelledBy="Select"
                        isLoading={isLoading}
                      />
                    </div>
                  </div>
                  <div className="col-4">

                    <div className="form-group">
                      <label>Search by Type {separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblSearchByType : ''}</label>
                      <select
                        className="form-control"
                        onChange={handleTypeChange}>
                        <option value="">Select Type{separator === true ? '/ ' : ''}{showTitle !== 'English' ? lblSelectType : ''}</option>
                        {typs.map((typ, index) =>
                          typ.total_documents > 0 && <option key={index} value={typ.typeID}>{typ.typeName}{separator === true ? '/ ' : ''}{typ.total_documents}{otherTyps[index]}</option>
                        )}

                      </select>
                    </div>
                  </div>
                </div>
                <button type="button" disabled={isLoader} className="btn btn-danger btn-block mt-4 filter" onClick={filterData}>
                  Search {separator === true ? '/ ' : ''}{showTitle !== 'English' ? btnSearch : ''}
                </button>
              </form>
            </div>
          </div>

        </div>

        <div className="container">
          <h5 className="mt-4">
            <strong> {showTitle !== 'English' ? lblDocumentList : ''} {separator === true ? '/ ' : ''} Documents List ({(typeof posts != 'undefined' && typeof posts.length != 'undefined' && !isFilterApplied) ? posts.length : filteredPost.length})</strong>
          </h5>

          {isLoader === true &&
            <Loader />
          }

          {isFilterApplied && typeof filteredPost != 'undefined' && filteredPost.map((post, index) => (

            <DocumentSection post={post} />
          ))}
          {!isFilterApplied && typeof posts != 'undefined' && posts.map((post, index) => (

            <DocumentSection post={post} />
          ))}

        </div>
      </div>
      <Link to="rechoose_language">
        <LanguageBtn />
      </Link>
    </div>
  );
};
export default News;
